import { Box } from 'components/Box';
import { Icon } from 'components/Icon';

import { PAGE_HEADER_NAV, PAGE_HEADER_NAV_MAP } from './PageHeaderConstants';
import { PageHeaderNavLink } from './PageHeaderNavLink';

type Props = {
  navSection: string;
  index: number;
  linkTo: string | { pathname: string; state: { redirectToContent?: boolean } };
  isStaff: boolean;
  type: string;
  setSearchFilter: (arg0: string, arg1: unknown) => unknown;
  isActive: (arg0: string) => boolean;
  navInactive: boolean;
  fullSize?: boolean;
  external?: boolean;
};

export function PageHeaderTopNavLink({
  navSection,
  index,
  linkTo,
  isStaff,
  type,
  isActive,
  navInactive,
  fullSize,
  external,
}: Props) {
  const additionalProps = external ? { target: '_blank' } : {};

  return (
    <Box
      position="relative"
      height={[null, null, null, '100%']}
      display={['inline-block', null, null, 'flex']}
      alignItems="center"
    >
      <PageHeaderNavLink
        data-qa-id={`nav-${type.toLowerCase().replace(/_/g, '-')}-link`}
        to={linkTo}
        isStaff={isStaff}
        active={isActive(type)}
        navInactive={navInactive}
        fullSize={fullSize}
        type={type}
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        mr={index < PAGE_HEADER_NAV[navSection].length - 1 && '1.5em'}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...additionalProps}
      >
        <Box classes={['flex', 'align-center']}>
          {
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            PAGE_HEADER_NAV_MAP[type]
          }
          {external && (
            <Box transform="translateZ(0)" ml="4px" display="inline-flex">
              <Icon name="arrow-up-right" size={9} />
            </Box>
          )}
        </Box>
      </PageHeaderNavLink>
    </Box>
  );
}
